import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { MapPin, Phone, Mail, ExternalLink } from 'lucide-react';

const Footer = () => {
  const { language } = useLanguage();

  return (
    <footer className="bg-primary text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="h-12 w-12 rounded-full bg-white p-2">
                <img 
                  src="/fbg-logo.png" 
                  alt="First Business Group" 
                  className="h-full w-full object-contain"
                />
              </div>
              <div>
                <h3 className="font-serif text-lg font-bold">First Business Group</h3>
                <p className="text-sm opacity-90">S.A.R.L.U.</p>
              </div>
            </div>
            <p className="text-sm opacity-90 leading-relaxed">
              {language === 'fr'
                ? 'Votre partenaire de confiance pour l\'investissement en République Démocratique du Congo.'
                : 'Your trusted partner for investment in the Democratic Republic of Congo.'}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-serif text-lg font-bold mb-4">
              {language === 'fr' ? 'Liens Rapides' : 'Quick Links'}
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-secondary transition-colors flex items-center">
                  {language === 'fr' ? 'Accueil' : 'Home'}
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-secondary transition-colors flex items-center">
                  {language === 'fr' ? 'À Propos' : 'About'}
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-secondary transition-colors flex items-center">
                  {language === 'fr' ? 'Services' : 'Services'}
                </Link>
              </li>
              <li>
                <Link to="/projects" className="hover:text-secondary transition-colors flex items-center">
                  {language === 'fr' ? 'Projets' : 'Projects'}
                </Link>
              </li>
              <li>
                <Link to="/investment-guide" className="hover:text-secondary transition-colors flex items-center">
                  {language === 'fr' ? 'Guide d\'Investissement' : 'Investment Guide'}
                </Link>
              </li>
              <li>
                <Link to="/company-formation" className="hover:text-secondary transition-colors flex items-center">
                  {language === 'fr' ? 'Création d\'Entreprise' : 'Company Formation'}
                </Link>
              </li>
              <li>
                <Link to="/videos" className="hover:text-secondary transition-colors flex items-center">
                  {language === 'fr' ? 'Vidéos' : 'Videos'}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-secondary transition-colors flex items-center">
                  {language === 'fr' ? 'Contact' : 'Contact'}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-serif text-lg font-bold mb-4">
              {language === 'fr' ? 'Contactez-nous' : 'Contact Us'}
            </h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-2">
                <MapPin className="h-4 w-4 mt-1 flex-shrink-0 text-secondary" />
                <span className="opacity-90 leading-relaxed">
                  #42 Immeuble Papa Victor, Local 11,<br />
                  Avenue Tombalbaye,<br />
                  Commune de la Gombe,<br />
                  Kinshasa, R.D. Congo
                </span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="h-4 w-4 flex-shrink-0 text-secondary" />
                <div>
                  <a href="tel:+243979097660" className="hover:text-secondary transition-colors block">
                    +243 97 90 97 660
                  </a>
                  <a href="tel:+243827777182" className="hover:text-secondary transition-colors block">
                    +243 82 77 77 182
                  </a>
                </div>
              </li>
              <li className="flex items-center space-x-2">
                <Mail className="h-4 w-4 flex-shrink-0 text-secondary" />
                <a href="mailto:info@fbgroup.cd" className="hover:text-secondary transition-colors">
                  info@fbgroup.cd
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 mt-8 pt-8 text-center">
          <p className="text-sm opacity-90">
            Copyright © FBG 2026 - {language === 'fr' ? 'Tous droits réservés' : 'All rights reserved'}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
